module.exports = __webpack_public_path__ + "static/media/toydoge6.72d9e90c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pc/toydoge6.png
// module id = 624
// module chunks = 0